import * as React from "react";
import classNames from "classnames";
import {ForwardRefComponent} from "./forwardRefType";
import "./CnStyles.scss";

const Table = React.forwardRef<
    HTMLTableElement,
    React.HTMLAttributes<HTMLTableElement>
>(({className, ...props}, ref) => (
    <div className="relative w-100 overflow-auto border-radius-5 border ">
        <table
            ref={ref}
            className={classNames("react-table", className)}
            {...props}
        />
    </div>
)) as ForwardRefComponent<HTMLTableElement, React.HTMLAttributes<HTMLTableElement>>;
Table.displayName = "Table";

const TableHeader = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({className, ...props}, ref) => (
    <thead ref={ref} className={classNames("table-header table-header-row", className)} {...props} />
)) as ForwardRefComponent<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>;
TableHeader.displayName = "TableHeader";

const TableBody = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({className, ...props}, ref) => (
    <tbody
        ref={ref}
        className={classNames("table-body table-body-row", className)}
        {...props}
    />
)) as ForwardRefComponent<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>;
TableBody.displayName = "TableBody";

const TableFooter = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({className, ...props}, ref) => (
    <tfoot
        ref={ref}
        className={classNames("table-footer table-footer-row", className)}
        {...props}
    />
)) as ForwardRefComponent<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>;
TableFooter.displayName = "TableFooter";

const TableRow = React.forwardRef<
    HTMLTableRowElement,
    React.HTMLAttributes<HTMLTableRowElement>
>(({className, ...props}, ref) => (
    <tr
        ref={ref}
        className={classNames("react-table-row", className)}
        {...props}
    />
)) as ForwardRefComponent<HTMLTableRowElement, React.HTMLAttributes<HTMLTableRowElement>>;
TableRow.displayName = "TableRow";

const TableHead = React.forwardRef<
    HTMLTableCellElement,
    React.ThHTMLAttributes<HTMLTableCellElement>
>(({className, ...props}, ref) => (
    <th
        ref={ref}
        className={classNames("table-head", className)}
        {...props}
    />
)) as ForwardRefComponent<HTMLTableCellElement, React.ThHTMLAttributes<HTMLTableCellElement>>;
TableHead.displayName = "TableHead";

const TableCell = React.forwardRef<
    HTMLTableCellElement,
    React.TdHTMLAttributes<HTMLTableCellElement>
>(({className, ...props}, ref) => (
    <td
        ref={ref}
        className={classNames("table-cell", className)}
        {...props}
    />
)) as ForwardRefComponent<HTMLTableCellElement, React.TdHTMLAttributes<HTMLTableCellElement>>;
TableCell.displayName = "TableCell";

const TableCaption = React.forwardRef<
    HTMLTableCaptionElement,
    React.HTMLAttributes<HTMLTableCaptionElement>
>(({className, ...props}, ref) => (
    <caption
        ref={ref}
        className={classNames("table-caption", className)}
        {...props}
    />
)) as ForwardRefComponent<HTMLTableCaptionElement, React.HTMLAttributes<HTMLTableCaptionElement>>;
TableCaption.displayName = "TableCaption";

export {
    Table,
    TableHeader,
    TableBody,
    TableFooter,
    TableHead,
    TableRow,
    TableCell,
    TableCaption,
};
